export default {
  state: {
    session: null,
    updated: false,
  },
  getters: {
    cognitoUserName: (state: any) => {
      const { session } = state;
      return session ? session.accessToken.payload.username : null;
    },
    accessToken: (state: any) => {
      const { session } = state;
      return session ? session.accessToken.jwtToken : null;
    },
    isExpiredSession: (state: any) => {
      const { session, updated } = state;
      return !session && updated;
    },
  },
  mutations: {
    updateSession: (state: any, res: any) => {
      state.session = res || null;
      state.updated = true;
    },
  },
};
